import React, { memo } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { DriverStatusType } from 'apps/fleet-planner/types'
import { FunctionalTag, IFunctionalTagOption, TAG_SIZE, TAG_STYLE } from 'transfix-ui'

interface IDriverStatusTag {
  driverStatus: DriverStatusType
  onSelectHandler: (selectedStatus: ISelectOption) => void
  label?: string
}

export const DriverStatusTag = memo<IDriverStatusTag>(({ driverStatus, onSelectHandler }) => {
  const statusOptions: IFunctionalTagOption[] = [
    {
      label: 'Active',
      value: DriverStatusType.active,
      style: TAG_STYLE.success,
    },
    {
      label: 'Deactivated',
      value: DriverStatusType.inactive,
      style: TAG_STYLE.dark,
    },
  ]

  return (
    <FunctionalTag
      size={TAG_SIZE.small}
      value={driverStatus}
      options={statusOptions}
      onSelect={onSelectHandler}
    />
  )
})
